import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, createTheme, CssBaseline } from '@mui/material';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { create } from 'jss';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { createGenerateClassName, StylesProvider, jssPreset } from '@mui/styles';
import { increaseSpecificity } from '../../utils/increaseSpecificity';
import { themeCommonConstants } from '../../constants/themeCommonConfig';
import useWidgetContext from '../../hooks/useWidgetContext';
import CONSTANTS from '../../constants/constants';
import stylisCustomPlugin from '../../utils/stylisCustomSpecificityPlugin';
const { STYLING_SEED } = CONSTANTS;
const generateClassName = createGenerateClassName({
    seed: STYLING_SEED,
    productionPrefix: 'PROD',
});
export const hooks = () => {
    const { configuration } = useWidgetContext();
    return { configuration };
};
export const BaseThemeProvider = {
    hooks,
    initialize: async () => ({
        theme: createTheme({}, themeCommonConstants),
    }),
    component: ({ theme, children }) => {
        const jss = create({
            ...jssPreset(),
            // extra specificity for the styles provider
            plugins: [...jssPreset().plugins, increaseSpecificity(4)],
        });
        const cache = createCache({
            key: STYLING_SEED,
            stylisPlugins: [stylisCustomPlugin],
        });
        return (_jsx("div", { style: { margin: 'auto', width: '100%' }, children: _jsx(CacheProvider, { value: cache, children: _jsx(StylesProvider, { generateClassName: generateClassName, jss: jss, children: _jsxs(MuiThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}, void 0), _jsx(Box, { color: 'text.primary', children: children }, void 0)] }, void 0) }, void 0) }, void 0) }, void 0));
    },
};
//# sourceMappingURL=BaseTheme.provider.js.map